import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl'
import { each, find } from 'lodash'

import { callApi } from '../services/fetchService'
import { loadGlobals } from '../actions'

import FaIcon from '../components/FaIcon'
import { Button, Form, Input, message, Tabs, Divider, Spin } from 'antd'
const FormItem = Form.Item
const InputGroup = Input.Group
const TabPane = Tabs.TabPane



/**
 * Norm form inside a tab
 */

class _NormsForm extends Component {

    static propTypes = {
        norms: PropTypes.object,
        onSubmit: PropTypes.func.isRequired,
        intl: intlShape.isRequired
    }

    state = {
        updating: false
    }
    
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.setState({ updating: true })
                this.props.onSubmit(this.props.norms.id, values)
                    .then(() => { this.setState({ updating: false })})
                    .catch(() => { this.setState({ updating: false })})
            }
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form
        const { norms } = this.props

        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
            style: { marginBottom: '10px' }
        }
        const tailFormItemLayout = {
            wrapperCol: { offset: 6, span: 18 },
        }

		if (!norms) {
			return (
                <div style={{ textAlign: 'center', marginTop: '50px' }}>
                    <Spin size="large" />
                </div>
            )
        }

        return (
            <Form layout="horizontal" onSubmit={this.handleSubmit} style={{ marginTop: "15px" }}>
                {
                    norms.data.map((item) => {
                        return (
                            <FormItem label={<FormattedMessage id={"bloodTest." + item.name} />} {...formItemLayout} key={item.name} className="norms-form">
                                <InputGroup compact>
                                    <FormItem style={{ marginBottom: 0 }}>{getFieldDecorator(item.name + '.down', {
                                        initialValue: item.down,
                                        rules:[{transform: (value) => value ? Number(value) : null, min: 0, type: 'number', message: ' '}]
                                    })(<Input addonBefore={<FaIcon icon="arrow-down" color="blue" />} style={{ width: 180}} />)}</FormItem>
                                    <FormItem style={{ marginBottom: 0 }}>{getFieldDecorator(item.name + '.up', {
                                        initialValue: item.up,
                                        rules:[{transform: (value) => value ? Number(value) : null, min: 0, type: 'number', message: ' '}]
                                    })(<Input addonBefore={<FaIcon icon="arrow-up" color="red" />} addonAfter={item.unit} style={{ width: 240}}  />)}</FormItem>
                                </InputGroup>
                            </FormItem>
                        )
                    })
                }
                <Divider />
                <FormItem {...tailFormItemLayout}>
                    <Button type="primary" loading={this.state.updating} htmlType="submit"><FormattedMessage id="misc.save" /></Button>
                </FormItem>
            </Form>
        )
    }

}
const NormsForm = injectIntl(Form.create()(_NormsForm))




class SettingsNorms extends Component {


    state = {
        data: [],
        formData: [],
        loading: false
    }

    static propTypes = {
        loadGlobals: PropTypes.func.isRequired,
        intl: intlShape.isRequired
    }

    fetch = (params = {}) => {
        const { intl } = this.props
        this.setState({ loading: true })
        callApi({
            endpoint: 'settings/norms'
        }).then((data) => {
            this.setState({
                data: data,
                formData: Object.assign({}, data),
                loading: false
            })
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
            this.setState({ loading: false })
        })
    }

    componentDidMount() {
        this.fetch()
    }

    save = (id, data) => {
        const { intl, loadGlobals } = this.props
        const { formData } = this.state
        const newNorms = Object.assign({}, find(formData, {id: id}))
        // Replace up/down data into new norms
        each(newNorms.data, (item) => {
            const { up, down } = data[item.name]
            item.up = (up !== null && up !== undefined && up !== '') ? Number(up) : null
            item.down = (down !== null && down !== undefined && down !== '') ? Number(down) : null 
        })
        // Save form state
        find(formData, {id: id}).data = newNorms.data
        this.setState({ formData: formData })
        // API call
        return callApi({
            endpoint: 'settings/norms/' + id,
            method: 'POST',
            body: newNorms
        }).then((data) => {
            message.success(intl.formatMessage({id: 'misc.updateSuccess'}))
            this.fetch()
            loadGlobals()
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
            return Promise.reject()
        })
    }

    /**
     * Render view
     */
    render() {
        const { formData } = this.state

        return (
            <div>
                <h1><FaIcon icon="cogs" fixedWidth /> <FormattedHTMLMessage id="settings.norms.title" /></h1>
                <Tabs defaultActiveKey="2">
                    <TabPane tab={<span><FaIcon icon="male" fixedWidth /> <FormattedMessage id="settings.norms.man" /></span>} key="man">
                        <NormsForm norms={find(formData, {key: 'man'})} onSubmit={this.save} />
                    </TabPane>
                    <TabPane tab={<span><FaIcon icon="female" fixedWidth /> <FormattedMessage id="settings.norms.woman" /></span>} key="woman">
                        <NormsForm norms={find(formData, {key: 'woman'})} onSubmit={this.save} />
                    </TabPane>
                    <TabPane tab={<span><FaIcon icon="child" fixedWidth /> <FormattedMessage id="settings.norms.child" /></span>} key="child">
                        <NormsForm norms={find(formData, {key: 'child'})} onSubmit={this.save} />
                    </TabPane>
                </Tabs>
            </div>
        )
    }

}

export default injectIntl(connect(null, {
    loadGlobals
})(SettingsNorms))


// WEBPACK FOOTER //
// ./src/views/SettingsNorms.js